import React, { useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { allFieldsFiltersTransformers, allFieldsListDefaultValues } from './FieldFilters/fieldFilterConfig';
import { CommonDataFieldsSelector, getDefaultCommonDataFilterValues } from './CommonDataFieldsSelector/CommonDataFieldsSelector';
import { useFilterForm, useFiltersChanged } from './Filters/useFilterForm';
import { useFilterPaginagion } from './Filters/auxiliaryFields';
import { useAllDatasetFields } from '../../shared/api/apiHooks';
import { filterFields } from './Filters/FilterFields/dataExplorerFieldsConfig';
import { AllFieldsListTable } from './AllFieldsListTable/AllFieldsListTable';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';
import { Breadcrumbs } from '../../components/Breadcrumbs/Breadcrumbs';
import { getMainDataPath } from './dataExplorerRouterPaths';
import { AllFieldFilters } from './FieldFilters/AllFieldFilters';
import { useDataExplorerTrackCustomEvent } from './Filters/dataExplorerAnalytics';
import { useWatch } from 'react-hook-form';
import { DataExplorerLink } from './dataExplorerHistoryContext';
import { hasConsultantOrResearcherPermission } from '../../reducers/AuthenticationReducer/AuthenticationSelector';
import { useSelector } from 'react-redux';

function AllFieldsList() {
  const defaultValues = useMemo(() => ({ ...allFieldsListDefaultValues, ...getDefaultCommonDataFilterValues() }), []);

  const { control, reset, debouncedQueryObject } = useFilterForm({
    fieldTransformers: allFieldsFiltersTransformers,
    defaultValues: defaultValues,
  });

  const filterPagination = useFilterPaginagion({ control, defaultValues });
  const fieldsResult = useAllDatasetFields({ queryObject: debouncedQueryObject });

  const isExtraFilterChanged = useFiltersChanged({
    control,
    fieldNames: [filterFields.alphaCount.name, filterFields.type.name],
    defaultValues,
  });

  const isPyramidMultiplierVisible = useSelector(hasConsultantOrResearcherPermission);

  const trackEvent = useDataExplorerTrackCustomEvent();
  const isSearchActive = (useWatch({ name: filterFields.search.name, control }) || '').trim() !== '';

  return (
    <div className="data-main">
      <div className="data__header-container">
        <div className="data-breadcrumbs">
          <Breadcrumbs
            items={[
              {
                LinkComponent: DataExplorerLink,
                link: getMainDataPath(),
                name: <FormattedMessageHelper id="dataExplorer.title" />,
                onClickCapture: () => {
                  trackEvent('de_click_breadcrumb_main');
                },
              },
              {
                name: <FormattedMessageHelper id={`dataExplorer.breadcrumbs.browseDataFields`} />,
              },
            ]}
          />
        </div>
        <CommonDataFieldsSelector control={control} />
      </div>

      <AllFieldFilters isExtraFilterChanged={isExtraFilterChanged} control={control} reset={reset} />
      <AllFieldsListTable
        isSearchActive={isSearchActive}
        filterPagination={filterPagination}
        control={control}
        result={fieldsResult}
        isPyramidMultiplierVisible={isPyramidMultiplierVisible}
      />
    </div>
  );
}

export default withRouter(AllFieldsList);
